module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/our_clients_img3.0cc0fcc4.png";